import React, { useState, useEffect } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	Spinner,
	Alert,
} from 'reactstrap';

// import { deleteResidue } from '../../../../slices/thunks';

// import { setRequireCloseModal } from '../../../../slices/residue/reducer';

import { useSelector, useDispatch } from 'react-redux';
import { finalDestinationReceptionGuide } from '../../../../../slices/thunks';
import { createSelector } from 'reselect';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import EditCertificationDataGuideForm from '../Forms/EditCertificationDataGuide';

const EditCertificationDataGuideModal = ({ dataGuide, isOpen, handlerToggleModal, handlerUpdateGuide }) => {

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handlerToggleModal()}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader >Editar kilogramos</ModalHeader>
				<ModalBody className=''>
					<EditCertificationDataGuideForm
						dataGuide={dataGuide}
						handleToggleModal={handlerToggleModal}
						handlerUpdateGuide={handlerUpdateGuide}
					/>
				</ModalBody>
			</Modal>
		</div>
	);
};

export default EditCertificationDataGuideModal;